import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Standard viewport reset

    setTimeout(()=>
    {
    window.scrollTo({ top: 0, left: 0});
    
    // Fallback if your CSS uses overflow layouts
    document.documentElement.scrollTo({ top: 0, left: 0});
    document.body.scrollTo({ top: 0, left: 0 });
    }, 0)
    
  }, [pathname]); // Fires every single time the URL route changes

  return ;
}